import { useTranslation } from "react-i18next";
import { ProductType } from "../../../shared/enums/ProductType";
import { localImages } from "../../shared/localImages";

export interface ToolsProductType {
  content: string;
  localImage: string;
  productType: ProductType;
  name: string;
}

interface ProductTypesOutput {
  toolsProductTypes: ToolsProductType[];
}

export const useProductTypes = (): ProductTypesOutput => {
  const { t } = useTranslation("tools");


  const toolsProductTypes = [
    {
      content: "",
      localImage: localImages.asphaltCutter,
      productType: ProductType.AsphaltCutters,
      name: `${t("asphaltcutter.asphaltcutter")}`,
    },
    {
      content: "",
      localImage: localImages.gravskopaTeeth,
      productType: ProductType.Buckets,
      name: `${t("buckets")}`,
    },
    {
      content: "",
      localImage: localImages.compactor,
      productType: ProductType.Compactors,
      name: `${t("compactor.compactor")}`,
    },
    {
      content: "",
      localImage: localImages.GB,
      productType: ProductType.GradingBeams,
      name: `${t("gradingbeam.gradingbeam")}`,
    },
    {
      content: "",
      localImage: localImages.multigrip,
      productType: ProductType.Grapples,
      name: `${t("grapple.grapple")}`,
    },
    {
      content: "",
      localImage: localImages.RG,
      productType: ProductType.GrappleModules,
      name: `${t("grapplemodule.grapplemodule")}`,
    },
    {
      content: "",
      localImage: localImages.jarnvagsgrip,
      productType: ProductType.RailGrapples,
      name: `${t("railroadgrapple.railroadgrapple")}`,
    },
    {
      content: "",
      localImage: localImages.ripper,
      productType: ProductType.Rippers,
      name: `${t("ripper.ripper")}`,
    },
  ];

  return {
    toolsProductTypes,
  };
};
